"use client";

import { memo } from "react";
import { ImageLoaderHandler } from "../ImageLoaderHandler/ImageLoaderHandler";
import { Image as ChakraImage } from "../ui/image";

export const Image = memo(
  /**
   * @param {Omit<import("@chakra-ui/react").ImageProps, "src"> & { src: string }} props
   */
  function Image({ src, ...otherProps }) {
    return (
      <ImageLoaderHandler src={src}>
        {({ ref, src, loaded: loaded, handleLoad }) => (
          <ChakraImage
            ref={ref}
            src={src}
            opacity={loaded ? 1 : 0}
            onLoad={handleLoad}
            transition={loaded ? "all .25s ease" : undefined}
            loading="lazy"
            alt=""
            {...otherProps}
          />
        )}
      </ImageLoaderHandler>
    );
  },
);
